import type { ApiValue } from './properties';

export enum PageCategory {
  Opportunities = 'Opportunities',
  Auth = 'Auth',
  SignUp = 'Sign Up',
  Partner = 'Partner',
  Volunteer = 'Volunteer',
  KindnessChallenge = 'Kindness Challenge'
}

export enum PageName {
  PartnerInterestForm = 'Partner Interest Form',
  KindnessChallengeForm = 'Kindness Challenge Form'
}

export interface BasePageProperties {
  [key: string]: ApiValue;
}

// Runtime lookup used by client implementations to derive category from name
export const pageCategoryMap: Record<PageName, PageCategory> = {
  [PageName.PartnerInterestForm]: PageCategory.SignUp,
  [PageName.KindnessChallengeForm]: PageCategory.KindnessChallenge
};

// Maps each PageName to its allowed properties (extend per-page as needed)
export type PagePropertiesMap = {
  [PageName.PartnerInterestForm]: BasePageProperties;
  [PageName.KindnessChallengeForm]: BasePageProperties;
};
